module.exports = __webpack_public_path__ + "static/google_img-ad9afb3fa4c7f9649eecfca9193e430b.png";